import React, { useEffect, useState } from 'react';
import { gameReviewService, imageService } from '../services';

const PopularReviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPopular = async () => {
      try {
        const res = await gameReviewService.getPopular();
        setReviews(res?.data?.content || []);
      } catch (err) {
        setError('Could not load popular reviews');
      } finally {
        setLoading(false);
      }
    };
    fetchPopular();
  }, []);

  return (
    <div style={{ textAlign: 'left' }}>
      <h2 style={{ fontWeight: 700, fontSize: 24, marginBottom: 18, textAlign: 'left' }}>Popular</h2>
      {loading && <div style={{ textAlign: 'left' }}>Loading...</div>}
      {error && <div style={{ color: 'red', textAlign: 'left' }}>{error}</div>}
      <div>
        {reviews.map((review, idx) => (
          <div
            key={review.id || idx}
            style={{ display: 'flex', alignItems: 'center', background: '#f9fafb', borderRadius: 10, marginBottom: 16, padding: 12, boxShadow: '0 2px 8px 0 rgba(0,0,0,0.04)', cursor: 'pointer', transition: 'box-shadow 0.18s' }}
            onClick={() => review.slug && window.open(`/review-game/${review.slug}`, '_self')}
            onMouseOver={e => e.currentTarget.style.boxShadow = '0 4px 16px 0 rgba(16,166,199,0.13)'}
            onMouseOut={e => e.currentTarget.style.boxShadow = '0 2px 8px 0 rgba(0,0,0,0.04)'}
          >
            <img
              src={imageService.getThumbnail(review.thumbnailPath)}
              alt={review.title}
              style={{ width: 48, height: 48, borderRadius: 8, objectFit: 'cover', marginRight: 16 }}
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 17, color: '#222', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'left' }}>{review.title}</div>
              <div style={{ color: '#6b7280', fontSize: 14, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', margin: '2px 0 4px 0', textAlign: 'left' }}>{review.description || review.shortDescription || ''}</div>
              <div style={{ textAlign: 'left' }}>
                {[...Array(5)].map((_, i) => (
                  <span key={i} style={{ color: i < Math.round(review.rateAverage) ? '#fbbf24' : '#e5e7eb', fontSize: '1.1rem' }}>★</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PopularReviews; 